var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import FunnelLoadingImage1Src from '@images/marketing/funnel/Funnel-Loading-1.jpg';
import FunnelLoadingImage2Src from '@images/marketing/funnel/Funnel-Loading-2.jpg';
import FunnelLoadingImage3Src from '@images/marketing/funnel/Funnel-Loading-3.jpg';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import { ProfilePageLayout, ProfilePageMain } from '@marketing/profile/common/ProfilePageLayout';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
var LOADING_STEP_TO_IMAGE_DATA = {
    0: {
        displayText: 'We’re reviewing PETNAME’s information…',
        image: {
            src: FunnelLoadingImage1Src,
            alt: 'Dog smiling with squinted eyes',
        },
    },
    1: {
        displayText: 'We’re creating PETNAME’s personal meal plan…',
        image: {
            src: FunnelLoadingImage2Src,
            alt: 'Dog smiling with open mouth',
        },
    },
    2: {
        displayText: 'Get ready to see PETNAME’s Nom Face!',
        image: {
            src: FunnelLoadingImage3Src,
            alt: 'Dog excited with wide open mouth catching a treat',
        },
    },
};
var PetCalculatingMealsPage = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), currentPet = _a.currentPet, currentPetIndex = _a.currentPetIndex, profileBasePath = _a.profileBasePath, sendFunnelGTMEvent = _a.sendFunnelGTMEvent;
    var _b = useState(0), loadingStep = _b[0], setLoadingStep = _b[1];
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    useEffect(function () {
        setIsLoading(true);
        var interval = setInterval(function () {
            setLoadingStep(function (prevStep) {
                var nextStep = prevStep + 1;
                if (nextStep >= 2) {
                    clearInterval(interval);
                    setIsLoading(false);
                    return 2;
                }
                return nextStep;
            });
        }, 1700);
    }, []);
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/health_concerns"), { viewTransition: true });
    };
    var handleClickNext = function () {
        sendFunnelGTMEvent('click-next_profile_stop');
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/meals"), { viewTransition: true });
    };
    var _d = LOADING_STEP_TO_IMAGE_DATA[loadingStep], displayText = _d.displayText, image = _d.image;
    return (_jsx(ProfilePageLayout, __assign({ handleClickNext: handleClickNext, handleClickPrevious: handleClickPrevious, isLoading: isLoading }, { children: _jsx(ProfilePageMain, __assign({ heading: displayText.replace('PETNAME', (currentPet === null || currentPet === void 0 ? void 0 : currentPet.name) || 'your dog'), imageData: image }, { children: _jsx(_Fragment, {}) })) })));
};
export default PetCalculatingMealsPage;
